import React, { useEffect, useState } from 'react';
import { CheckCircle2, Circle, AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../../components/ui/dialog';
import { fmtDate } from './crmConstants';

export const MyTasksDialog = ({ open, onClose, api, isAdmin, onOpenLead }) => {
  const [scope, setScope] = useState('mine');
  const [tasks, setTasks] = useState([]);
  const load = () => api.get('/admin/lead-tasks', { scope }).then(setTasks).catch(() => {});
  useEffect(() => { if (open) load(); }, [open, scope]);
  const done = async (t) => { await api.patch(`/admin/lead-tasks/${t.id}`, { done: true }); load(); };
  const now = new Date().toISOString();
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl bg-slate-800 border-slate-700 text-white max-h-[90vh] overflow-y-auto" data-testid="my-tasks-dialog">
        <DialogHeader>
          <DialogTitle>Agenda attività</DialogTitle>
          <DialogDescription className="text-slate-400">Tutte le prossime azioni aperte, le più urgenti in alto.</DialogDescription>
        </DialogHeader>
        {isAdmin && (
          <div className="flex gap-1.5">
            {[['mine', 'Le mie'], ['all', 'Tutto il team']].map(([id, label]) => (
              <button key={id} onClick={() => setScope(id)} className={`px-3 py-1 rounded-full text-xs ${scope === id ? 'bg-amber-500 text-slate-950 font-semibold' : 'bg-slate-700 text-slate-200'}`} data-testid={`tasks-scope-${id}`}>{label}</button>
            ))}
          </div>
        )}
        <div className="space-y-1.5">
          {tasks.map((t) => {
            const late = t.due_at && t.due_at < now;
            return (
              <div key={t.id} className={`flex items-center gap-3 px-3 py-2 rounded-lg border ${late ? 'border-rose-500/40 bg-rose-500/5' : 'border-slate-700 bg-slate-900/50'}`} data-testid={`agenda-task-${t.id}`}>
                <button onClick={() => done(t)} title="Segna come fatta" data-testid={`agenda-done-${t.id}`}><Circle className="w-5 h-5 text-slate-500 hover:text-emerald-400" /></button>
                <button onClick={() => onOpenLead(t.lead_id)} className="flex-1 min-w-0 text-left">
                  <p className="text-sm text-white truncate">{t.title}</p>
                  <p className="text-[11px] text-slate-400 flex items-center gap-1">{late && <AlertTriangle className="w-3 h-3 text-rose-400" />}{t.lead_name} · {t.due_at ? fmtDate(t.due_at) : 'senza scadenza'} · {t.assignee_name}</p>
                </button>
              </div>
            );
          })}
          {!tasks.length && <p className="text-center text-sm text-slate-500 py-8 flex items-center justify-center gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400" /> Nessuna attività aperta</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
